export default {
    data: [],
    fetched: false,
    name: "",
    country: "",
    address: "",
    contact_userId:'',
    formSelect: [],
    notification: null
};